<router-outlet></router-outlet>

<!--<div class="v4-layout-content">-->
<!--  <nz-tabset nzSize="large" nzLinkRouter [nzLinkExact]="false">-->
<!--    <nz-tab>-->
<!--      <a *nzTabLink nz-tab-link [routerLink]="['./account']">-->
<!--        <span>{{ "channel.tab.manager" | translate }}</span>-->
<!--        <nz-badge [nzCount]="unreadCount || 0" class="badge"></nz-badge>-->
<!--      </a>-->
<!--      <ng-template nz-tab>-->
<!--        <div class="channel-container">-->
<!--          <host-account></host-account>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--    </nz-tab>-->
<!--    <nz-tab>-->
<!--      <a *nzTabLink nz-tab-link [routerLink]="['./relation']">-->
<!--        {{ "channel.tab.relation" | translate }}-->
<!--      </a>-->
<!--      <ng-template nz-tab>-->
<!--        <div class="channel-container">-->
<!--          <host-house-relation></host-house-relation>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--    </nz-tab>-->
<!--    <nz-tab>-->
<!--      <a *nzTabLink nz-tab-link [routerLink]="['./house']">-->
<!--        {{ "channel.tab.house" | translate }}-->
<!--      </a>-->
<!--      <ng-template nz-tab>-->
<!--        <div class="channel-container">-->
<!--          <host-channel-house></host-channel-house>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--    </nz-tab>-->
<!--  </nz-tabset>-->
<!--</div>-->
